
// src/services/axiosInstanceMultipart.js
import axios from 'axios';

const getToken = () => {
    const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
    return match ? match[2] : null;
};

const configFile = await fetch('/config.json');
const fileConfig = await configFile.json();
const baseURL = fileConfig.API_BASE_URL;
const axiosInstanceMultipart = axios.create({

    baseURL: baseURL,
    headers: {
        'Content-Type': 'multipart/form-data',
    },
    timeout: 10000,
});

// افزودن اینترسپتور برای Authorization
axiosInstanceMultipart.interceptors.request.use(
    (config) => {
        const token = getToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export default axiosInstanceMultipart;
